module.exports = __webpack_public_path__ + "static/img/list-dreamWearSiliconePillowMask.33d50e8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/maskPng/list-dreamWearSiliconePillowMask.png
// module id = LLzb
// module chunks = 1